import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

// recommended funds/fetchAll <- funds/fetchFunds
export const fetchFunds = createAsyncThunk('funds/fetchAll', async () => {
  const res = await api.get('/funds');
  return res.data;
});

// recommended funds/fetchOne <- funds/fetchFundDetail
export const fetchFundDetail = createAsyncThunk('funds/fetchOne', async (id) => {
  const res = await api.get(`/funds/${id}`);
  return res.data;
});

const fundSlice = createSlice({
  name: 'funds',
  initialState: { list: [], detail: null, loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFunds.pending, (state) => { state.loading = true; })
      .addCase(fetchFunds.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchFundDetail.fulfilled, (state, action) => {
        state.detail = action.payload;
      });
  },
});

export default fundSlice.reducer;

